import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
  address,
  bniLogoUrl,
  instagramUrl,
  mapUrl,
  phoneNumber,
  phoneNumber2,
  whatsappSubscriptionUrl,
  whatsappUrl,
} from "../constants/business";
import { SECTION_IDS } from "../constants/sections";
import { CONTACT_STRINGS } from "../constants/strings";
import EnquiryForm from "./EnquiryForm";

function ContactSection() {
  return (
    <section id={SECTION_IDS.contact} className="section contact-section">
      <div className="section-inner">
        <div id={SECTION_IDS.enquiry} className="enquiry-panel">
          <div className="enquiry-panel-text">
            <p className="eyebrow">{CONTACT_STRINGS.enquiryPanel.eyebrow}</p>
            <h3>{CONTACT_STRINGS.enquiryPanel.heading}</h3>
            <p>{CONTACT_STRINGS.enquiryPanel.paragraph}</p>
            <a
              className="button button-primary"
              href={whatsappSubscriptionUrl}
              target="_blank"
              rel="noreferrer"
            >
              {CONTACT_STRINGS.enquiryPanel.whatsappCta}
            </a>
          </div>

          <div className="enquiry-form-slot">
            <EnquiryForm />
          </div>
        </div>

        <div className="contact-grid">
          <div>
            <p className="eyebrow">{CONTACT_STRINGS.eyebrow}</p>
            <h2>{CONTACT_STRINGS.heading}</h2>
            <div className="contact-list">
              <p>
                <span>{CONTACT_STRINGS.labels.phone}</span>
                <a href="tel:+919150455866">{phoneNumber}</a>,
                <a href="tel:+91915720866">{phoneNumber2}</a>
              </p>
              <p>
                <span>{CONTACT_STRINGS.labels.instagram}</span>
                <a href={instagramUrl} target="_blank" rel="noreferrer">
                  {CONTACT_STRINGS.instagramHandle}
                </a>
              </p>
              <p>
                <span>{CONTACT_STRINGS.labels.location}</span>
                {address}
              </p>
              <p>
                <span>{CONTACT_STRINGS.labels.hours}</span>
                {CONTACT_STRINGS.hours}
              </p>
              <p className="contact-bni-row">
                <span className="contact-bni-inline">
                  <img src={bniLogoUrl} alt="BNI" className="bni-logo" />
                  {CONTACT_STRINGS.bniMemberText}
                </span>
              </p>
            </div>

            <div
              className="social-row"
              aria-label={CONTACT_STRINGS.socialAriaLabel}
            >
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noreferrer"
                aria-label={CONTACT_STRINGS.whatsappAriaLabel}
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
              <a
                href={instagramUrl}
                target="_blank"
                rel="noreferrer"
                aria-label={CONTACT_STRINGS.instagramAriaLabel}
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>

          <iframe
            title={CONTACT_STRINGS.mapTitle}
            src={mapUrl}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
